import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getMe } from '../api/authApi';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Login only exists on Portal. A shared cross-subdomain cookie (set by
  // Portal at login) is what proves who this is here — verified fresh on
  // every load, no local token to check first.
  useEffect(() => {
    getMe()
      .then((u) => setUser(u))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  // "Back Home" — a real cross-origin redirect to Portal's module launcher.
  // This is not a sign-out: the shared session cookie is untouched, so
  // whatever the user opens next (Portal itself, or another module) is
  // still logged in.
  const goHome = useCallback(() => {
    const portalUrl = process.env.REACT_APP_PORTAL_URL;
    window.location.href = portalUrl || '/';
  }, []);

  const hasPermission = useCallback((permission) => {
    if (!user) return false;
    if (user.permissions === 'ALL') return true;
    return Array.isArray(user.permissions) && user.permissions.includes(permission);
  }, [user]);

  const isAdmin = user?.role === 'ADMIN';

  return (
    <AuthContext.Provider value={{ user, loading, goHome, hasPermission, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
